<template>
  <div class="Regusers">
    <app-header></app-header>

    <el-container style="border: 1px solid #eee">
      <app-sidebar></app-sidebar>
      <el-main>
        <app-breadcrumb></app-breadcrumb>
        <el-form :inline="true" :model="formInline" class="demo-form-inline" disabled>
          <el-form-item label="用户名">
            <el-input v-model="formInline.user" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="formInline.pwd" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">立即创建</el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'Regusers',
  data() {
    return {
      formInline: {
        user: '',
        pwd: ''
      }
    }
  },
  methods: {
    onSubmit() {
      console.log('submit!')
    }
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 30px;
}
</style>
